<!-- 资源-播放音频弹窗-吴影茹 -->
<template>
  <OyModal v-model:open="modalVisible" title="播放音频" :width="600" @cancel="cancelHandler" :customFooter="true">
    <audio :src="url" controls style="width: 100%" v-if="modalVisible"></audio>
    <template #footer>
      <a-button @click="cancelHandler">关 闭</a-button>
    </template>
  </OyModal>
</template>
                    
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import videojs from 'video.js'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  url: {
    type: String,
    default: ''
  }
})

onMounted(() => {})
const emit = defineEmits(['update:visible'])

const modalVisible = ref<boolean>(false)

watch(
  () => props.visible,
  (newVal) => {
    modalVisible.value = newVal
  },
  { immediate: true }
)

// 关闭
const cancelHandler = () => {
  emit('update:visible', false)
}
</script>
                    
<style lang="scss" scoped>
.video_content {
  width: 100%;
  height: 100%;
}
</style>